module.exports = __webpack_public_path__ + "image/qr_applet_f6d9a.jpg";